<div class="flex items-center gap-3 mb-4">
  @if (showBackButton) {
    <button
      (click)="goBack()"
      class="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors cursor-pointer border-none bg-transparent"
      >
      <i class="pi pi-arrow-left text-surface-600 dark:text-surface-300"></i>
    </button>
  }
  <span class="text-xl font-bold text-surface-900 dark:text-surface-0">{{ modalTitle | zDictionary }}</span>
</div>

<zaeper-content-slider>
  <!-- Slide 0: Choose create or join -->
  <zaeper-content-slide [centered]="false">
    <div class="flex flex-col gap-6">
      <div class="text-center flex flex-col items-center gap-3">
        <img src="assets/images/zaeper_logo_z.svg" alt="Zaeper" class="w-14 h-14 dark:hidden" />
        <img src="assets/images/zaeper_logo_z_white.svg" alt="Zaeper" class="w-14 h-14 hidden dark:block" />
        <p class="text-sm text-surface-500">
          {{ "wizard-welcome-description" | zDictionary }}
        </p>
      </div>

      <div class="flex flex-col gap-3">
        <button
          (click)="selectCreate()"
          class="w-full flex items-center gap-5 p-5 rounded-xl bg-surface-50 dark:bg-surface-800 hover:bg-surface-100 dark:hover:bg-surface-700 transition-colors duration-200 text-left cursor-pointer border border-surface-200 dark:border-surface-700"
          >
          <div class="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <i class="pi pi-building text-xl text-primary"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-surface-900 dark:text-surface-0 mb-1">{{ "wizard-create-option-title" | zDictionary }}</div>
            <div class="text-sm text-surface-500 dark:text-surface-400">{{ "wizard-create-option-description" | zDictionary }}</div>
          </div>
          <i class="pi pi-arrow-right text-surface-400"></i>
        </button>

        <button
          (click)="selectJoin()"
          class="w-full flex items-center gap-5 p-5 rounded-xl bg-surface-50 dark:bg-surface-800 hover:bg-surface-100 dark:hover:bg-surface-700 transition-colors duration-200 text-left cursor-pointer border border-surface-200 dark:border-surface-700"
          >
          <div class="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <i class="pi pi-users text-xl text-primary"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-surface-900 dark:text-surface-0 mb-1">{{ "wizard-join-option-title" | zDictionary }}</div>
            <div class="text-sm text-surface-500 dark:text-surface-400">{{ "wizard-join-option-description" | zDictionary }}</div>
          </div>
          <i class="pi pi-arrow-right text-surface-400"></i>
        </button>
      </div>
    </div>
  </zaeper-content-slide>

  <!-- Slide 1: Create or join form -->
  <zaeper-content-slide>
    <div class="flex flex-col gap-5 w-full">
      <!-- Create Company Form -->
      @if (selectedMode === 'create') {
        <form (submit)="submitCreateCompany($event)" [formGroup]="createCompanyForm" class="w-full">
          <div class="flex flex-col gap-4">
            <zaeper-input-text [inputOptions]="nameInputOptions"></zaeper-input-text>
            <zaeper-input-text [inputOptions]="shortcodeInputOptions"></zaeper-input-text>
            <zaeper-input-text [inputOptions]="descriptionInputOptions"></zaeper-input-text>
            <div class="flex flex-col gap-2">
              <label for="company-country" class="font-medium">{{ "wizard-company-country" | zDictionary }} *</label>
              <zaeper-country-select
                inputId="company-country"
                [country]="createCompanyForm.get('country')?.value"
                (countryChange)="createCompanyForm.get('country')?.setValue($event)"
                [placeholder]="'wizard-company-country-placeholder' | zDictionary"
              />
              <small class="text-surface-500 dark:text-surface-400">{{ "wizard-company-country-hint" | zDictionary }}</small>
            </div>
            <div class="flex justify-end mt-2">
              <p-button
                [rounded]="true"
                type="submit"
                [disabled]="createCompanyForm.invalid || isSubmitting"
                [loading]="isSubmitting"
                [label]="'wizard-create-submit' | zDictionary"
              ></p-button>
            </div>
          </div>
        </form>
      }

      <!-- Join Company Form -->
      @if (selectedMode === 'join') {
        <form (submit)="submitJoinRequest($event)" [formGroup]="joinCompanyForm" class="w-full">
          <div class="flex flex-col gap-4">
            <zaeper-input-text [inputOptions]="joinCodeInputOptions"></zaeper-input-text>
            <div class="flex justify-end mt-2">
              <p-button
                [rounded]="true"
                type="submit"
                [disabled]="joinCompanyForm.invalid || isSubmitting"
                [loading]="isSubmitting"
                [label]="'wizard-join-submit' | zDictionary"
              ></p-button>
            </div>
          </div>
        </form>
      }
    </div>
  </zaeper-content-slide>

  <!-- Slide 2: Pending join request -->
  <zaeper-content-slide [centered]="true">
    <div class="flex flex-col items-center gap-6 py-8">
      <div class="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
        <i class="pi pi-spin pi-spinner text-2xl text-primary"></i>
      </div>
      <div class="text-center">
        <h3 class="text-lg font-semibold text-surface-900 dark:text-surface-0 mb-2">{{ "wizard-pending-title" | zDictionary }}</h3>
        <p class="text-sm text-surface-500 dark:text-surface-400">{{ "wizard-pending-description" | zDictionary }}</p>
      </div>
    </div>
  </zaeper-content-slide>
</zaeper-content-slider>
